
import { HyperLinkBuilder, SimpleLinkRenderer } from "widgets/commonComponents/inline/hyperLink"
import { MenuItems } from "./audioHeaderComponenta"


interface MainNavProps {
    navItems: MenuItems[]
    bgColor?: string
    termsLink?: string
    contactUsLink?: string
    accessibilityLink?: string
}
interface MainNavState {
   isOpened: boolean
}
export class AudioHeaderNavMutam extends React.Component<MainNavProps, MainNavState> {
      public static siteScriptName = "AudioHeaderNavMutam"
    constructor(props) {
        super(props)
        this.state = {
            isOpened: false,
        }
    }
    private openMenu = () => {
        this.setState({ isOpened: !this.state.isOpened })
        document.body.classList.toggle('lock-scroll');
    }
    render() {
        const {  navItems, bgColor, termsLink, contactUsLink, accessibilityLink } = this.props
        const { isOpened } = this.state


        return (
            <div className={`mainNav`} role="navigation" aria-label="Main Menu">
                  <button className="menuHamburger" onClick={this.openMenu} />
                <div className={`navList ${isOpened ? "opened" : ""}`} style={{background:bgColor}}>
                   <div className="navListItems">
                    {_.map((navItems), (item: MenuItems, index: number) => <div key={index} >
                        <HyperLinkBuilder href={item.link} linkTarget={item.linkTarget}>
                            {item.title}
                        </HyperLinkBuilder>
                    </div>)}
                   </div>
                  <div className="navListItems">
                    <SimpleLinkRenderer href={termsLink} >תנאי שימוש</SimpleLinkRenderer>
                     <SimpleLinkRenderer href={accessibilityLink} >הצהרת נגישות</SimpleLinkRenderer>
                    <SimpleLinkRenderer href={contactUsLink} >צרו קשר</SimpleLinkRenderer>
                  
                  </div>
                  <div className="navFooter">powered by ynet + Bi.Zi</div>
             
            </div>
            </div>
        )
    }
}